import { useJobDeposit } from "hook/bailiff/job/action/useJobDeposit";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { bailiffJobDetailSelector } from "store/bailiff/bailiff/job/bailiff_job.selector";
import { orderBailiffQrSelector } from "store/bailiff/payment/order/order_bailiff.selector";
//
//component
//redux
//selector
//actions
//
const STATUS = ["waiting for deposit"];
export const TriggerClose = () => {
  // -------------------------- VAR ----------------------------
  const { handleClose } = useJobDeposit();
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  const qr = useSelector(orderBailiffQrSelector);
  const detail = useSelector(bailiffJobDetailSelector);
  const status = detail?.status || false;
  const valids = (status && STATUS?.includes(status)) || false;
  const open = !!qr;

  // -------------------------- USE EFFECT ---------------------
  useEffect(() => {
    if (open && !valids && detail) {
      console.log("trigger close");
      handleClose();
    }
  }, [valids, handleClose, detail, open]);
  // -------------------------- RETURN --------------------------
  return <></>;
};
export default TriggerClose;
